import React, { useContext } from 'react';
import TaskMasterTable from './TaskMasterTable';
import { CommonContext, TaskMasterContext } from '../../context';
import { Box, Button, CardHeader, Paper } from '@mui/material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import FilterBar from './FilterBar';

export default function TaskMasterScreenview() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading, handleAddModal } = useContext(TaskMasterContext);

    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <Box className="component-header">
                <CardHeader title="Task Master" />
                <Box className="action-btns-group">
                    <Button variant="outlined" className="action-btn" onClick={handleAddModal}>
                        Add Task Master
                    </Button>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: 'none' }}>
                <FilterBar />
                <TaskMasterTable />
            </Paper>
        </div>
    );
}
